import { useState, useEffect, useCallback } from "react";
import api from "../../../api";

const useFetchDataPosConsult = (url, options = {}) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [refetching, setRefetching] = useState(false);
  const [error, setError] = useState(null);

  // Serializa o options para comparação segura
  const optionsString = JSON.stringify(options);

  const fetchData = useCallback(
    async (isRefetch = false) => {
      const parsedOptions = JSON.parse(optionsString); // reconstrói o objeto

      if (isRefetch) {
        setRefetching(true);
      } else {
        setLoading(true);
      }

      setError(null);

      try {
        const response = await api.post(url, parsedOptions);
        setData(response.data);
      } catch (err) {
        setError(err);
      } finally {
        if (isRefetch) {
          setRefetching(false);
        } else {
          setLoading(false);
        }
      }
    },
    [url, optionsString] // agora depende só da string, não do objeto
  );

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const refetch = () => fetchData(true);

  return { data, loading, error, refetch, refetching };
};

export default useFetchDataPosConsult;
